import { NoteTooltipResponse } from '@/types/service-response'

export class NoteTooltip {
  private constructor (
    readonly employeeName: string,
    readonly responsibleName: string,
    readonly address: string,
    readonly email: string,
    readonly employeeMobile: string,
    readonly mobile: string,
    readonly departmentName: string,
    readonly note: string,
    readonly preferences: string,
    readonly pauseText?: string | null,
  ) {}

  public static createFromResponse (data: NoteTooltipResponse): NoteTooltip {
    return new NoteTooltip(
      data.MitarbeiterName_STV ? data.MitarbeiterName_STV : '',
      data.MitarbeiterName ? data.MitarbeiterName : '',
      data.GenAdresse ? data.GenAdresse : '',
      data.EMail ? data.EMail : '',
      data.MAMobil ? data.MAMobil : '',
      data.Mobil ? data.Mobil : '',
      data.AbteilungBezeichnung ? data.AbteilungBezeichnung : '',
      data.Note ? data.Note : '',
      data.Preferences ? data.Preferences : '',
      data.PausenText ? data.PausenText : null
    )
  }
}
